import React, { Component } from 'react';
import axios, { get } from 'axios';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import './App.css';

let timeout = null;

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayBooks: [],
        };

        this.getResult = this.getResult.bind(this);
    }

    componentDidMount(){
        this.nameInput.focus();
    }

    getResult(e){
        let val = e.target.value;
        clearTimeout(timeout);
        let resp =

            e.target.value.length > 3 ?

                                    timeout = setTimeout( () => {

                                        axios.get(`https://www.googleapis.com/books/v1/volumes?q=${ val }`)
                                            .then((response) => {
                                                let books = response.data.items.map(person => person);
                                                this.setState({displayBooks: books});
                                            });

                                    }, 2000)

                                    : '' ;

    }

    render(){

        let book = this.state.displayBooks.map((elem, id) => {

            let src = elem.volumeInfo.imageLinks ?  elem.volumeInfo.imageLinks.thumbnail : 'no.jpg';

            return (
                    <div className="align-left" key={id}>
                        <div className="wrapper-img"><img src={src} alt={elem.volumeInfo.title}/></div>
                        <div className="wrapper-item">
                            <div className="item-number"><a href={elem.volumeInfo.previewLink} target="_blank" >Title: {elem.volumeInfo.title}</a></div>
                            <div className="item-author">Author: {elem.volumeInfo.authors}</div>
                            <div className="item-page">Pages: {elem.volumeInfo.pageCount}</div>
                            <div className="item-number">Description: {elem.volumeInfo.description}</div>
                        </div>
                    </div>
            )
        });

        return (
            <div className="aligned-vert">
                <MuiThemeProvider>
                    <TextField
                        hintText = "Search + Terms"
                        floatingLabelText = "Input value for searching books ..."
                        onChange = {this.getResult}
                        className="book-search-input"
                        type = "text"
                        ref={(input) => { this.nameInput = input; }}
                    />
                </MuiThemeProvider>
                {book}
            </div>
        )

    }


}
export default App;



// WEBPACK FOOTER //
// ./src/App.js